import React from 'react';
import { useCurrentUser, useTranslate } from '@hooks';
import { compact, trim } from 'lodash';
import { toArray } from '@dotone/react-ui-core/utils';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import {
  FormFilter as Form,
  // AffiliateLabelSelect,
  // AffiliateSourceSelect,
  GenderSelect,
  BooleanSelect,
  Input,
} from '@dotone/react-ui-core';
import {
  MediaCategorySelect,
  CountrySelect,
  CategoryGroupSelect,
  OfferSearchInput,
  AffiliateSourceTypeSelect,
} from '../forms';

const AffiliateFilterForm = ({
  defaultValues: givenDefaultValues = {},
  onSubmit,
  ...otherProps
}) => {
  const { t } = useTranslate('affiliate', 'model');
  const { t: tCampaign } = useTranslate('campaign', 'model');
  const { currentUser } = useCurrentUser();

  const defaultValues = {
    ...givenDefaultValues,
    ids: toArray(givenDefaultValues.ids).join(','),
  };

  const handleSubmit = (values) => {
    onSubmit({
      ...values,
      ids: compact(toArray(values.ids).join(',').split(',').map(trim)),
    });
  };

  return (
    <Form defaultValues={defaultValues} onSubmit={handleSubmit} {...otherProps}>
      <Row>
        {!currentUser.singleOffer && (
          <Col md={6} lg={4} xl={3}>
            <FormGroup>
              <Label>{t('common:model.offer')}</Label>
              <OfferSearchInput multi name="offerIds" />
            </FormGroup>
          </Col>
        )}
        {/* <Col md={6} lg={4} xl={3}> */}
        {/*   <FormGroup> */}
        {/*     <Label>{t('label')}</Label> */}
        {/*     <AffiliateLabelSelect multi name="labels" /> */}
        {/*   </FormGroup> */}
        {/* </Col> */}
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('affiliateType')}</Label>
            <MediaCategorySelect multi name="mediaCategoryIds" />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('categoryGroups')}</Label>
            <CategoryGroupSelect multi name="categoryGroupIds" />
          </FormGroup>
        </Col>
        {currentUser.canAccessAffiliate && (
          <Col md={6} lg={4} xl={3}>
            <FormGroup>
              <Label>{t('::common:model.country')}</Label>
              <CountrySelect multi name="countryIds" />
            </FormGroup>
          </Col>
        )}
        {/* <Col md={6} lg={4} xl={3}> */}
        {/*   <FormGroup> */}
        {/*     <Label>{t('source')}</Label> */}
        {/*     <AffiliateSourceSelect multi name="sources" /> */}
        {/*   </FormGroup> */}
        {/* </Col> */}
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('gender')}</Label>
            <GenderSelect multi name="genders" />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{tCampaign('isCustomPayout')}</Label>
            <BooleanSelect name="isCustomPayout" />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('sourceType')}</Label>
            <AffiliateSourceTypeSelect name="sourceType" />
          </FormGroup>
        </Col>
        {!currentUser.pro && (
          <Col md={6} lg={4} xl={3}>
            <FormGroup>
              <Label>{t('common:model.affiliate')}</Label>
              <Input name="ids" />
            </FormGroup>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default AffiliateFilterForm;
